export const primaryBase = {
  background: 'linear-gradient(180deg, #605AFB 0%, #503BF0 100%)',
  color: 'primary-25',
  border: 'none',
  fontSize: '0.875rem', // 14px
  // 550 like every sibling variant and like @kula-ai/components' Button; this
  // one had drifted to 650.
  fontWeight: 550,
  borderRadius: '6px',
  _hover: {
    background: 'linear-gradient(180deg, #503BF0 0%, #442ED4 100%)',
    _disabled: {
      background: 'secondary-50',
      color: 'secondary-500',
    },
  },
  _active: {
    backgroundColor: '#E9EBF4',
  },
  _disabled: {
    background: 'secondary-50',
    color: 'secondary-500',
  },
};

export const secondaryBase = {
  backgroundColor: 'base-white',
  color: 'primary-500',
  border: '1px solid',
  borderColor: 'primary-500',
  fontSize: '0.875rem', // 14px
  fontWeight: 550,
  borderRadius: '6px',
  _hover: {
    backgroundColor: 'secondary-50',
    borderColor: 'primary-600',
    color: 'primary-600',
    _disabled: {
      borderColor: 'secondary-500',
      color: 'secondary-500',
    },
  },
  _active: {
    backgroundColor: 'secondary-100',
    borderColor: 'primary-700',
    color: 'primary-700',
  },
  _disabled: {
    borderColor: 'secondary-500',
    color: 'secondary-500',
  },
};

export const tertiaryBase = {
  backgroundColor: 'primary-100',
  color: 'primary-600',
  borderColor: 'transparent',
  fontSize: '0.875rem', // 14px
  fontWeight: 550,
  borderRadius: '6px',
  _hover: {
    backgroundColor: 'primary-200',
    color: 'primary-700',
    _disabled: {
      backgroundColor: 'secondary-25',
      color: 'secondary-500',
    },
  },
  _active: {
    backgroundColor: 'primary-300',
    color: 'primary-800',
  },
  _disabled: {
    backgroundColor: 'secondary-25',
    color: 'secondary-500',
  },
};

export const quaternaryBase = {
  backgroundColor: 'base-white',
  color: 'secondary-700',
  border: '1px solid',
  borderColor: 'secondary-100',
  fontSize: '0.875rem', // 14px
  fontWeight: 550,
  padding: '6px 12px',
  borderRadius: '6px',
  _hover: {
    backgroundColor: 'secondary-25',
    color: 'secondary-900',
    _disabled: {
      backgroundColor: 'secondary-25',
      borderColor: 'secondary-25',
      color: 'secondary-500',
    },
  },
  _active: {
    backgroundColor: 'secondary-100',
    borderColor: 'secondary-100',
    color: 'secondary-900',
  },
  _disabled: {
    backgroundColor: 'secondary-25',
    borderColor: 'secondary-25',
    color: 'secondary-500',
  },
};

export const dangerBase = {
  backgroundColor: 'error-200',
  color: 'primary-25',
  border: '1px solid',
  borderColor: 'error-200',
  fontSize: '0.875rem', // 14px
  fontWeight: 550,
  padding: '6px 12px',
  borderRadius: '6px',
  _hover: {
    backgroundColor: 'error-100',
    borderColor: 'error-100',
    color: 'primary-25',
    _disabled: {
      backgroundColor: 'secondary-25',
      borderColor: 'secondary-25',
      color: 'secondary-500',
    },
  },
  _active: {
    backgroundColor: 'error-200',
    borderColor: 'error-300',
    color: 'primary-25',
  },
  _disabled: {
    backgroundColor: 'secondary-25',
    borderColor: 'secondary-25',
    color: 'secondary-500',
  },
};

export const Button = {
  baseStyle: {
    borderRadius: 'sm',
    _focus: { outline: 'none', boxShadow: 'none' },
    _active: { outline: 'none' },
    padding: 'md',
    _disabled: {
      boxShadow: 'none',
      pointerEvent: 'none',
      opacity: 1,
    },
  },
  variants: {
    // primary: () => ({
    //   fontWeight: 'bold',
    //   bg: 'light.primary-button', // '#0043CE',
    //   color: 'white',
    //   _hover: {
    //     bg: 'light.primary-button-active', // '#0043CE',
    //     _disabled: {
    //       bg: 'dark.primary-button', // '#0043CE',
    //       opacity: 0.3,
    //     },
    //   },
    // }),

    // secondary: (props) => ({
    //   fontWeight: 600,
    //   bg: props.colorMode === 'dark' ? 'black' : 'white',
    //   borderColor: props.colorMode === 'dark' ? 'dark.border' : 'light.border',
    //   borderWidth: '1px',
    // }),

    icon: () => ({
      bg: '#FFFFFF',
      borderColor: 'border-color',
      borderWidth: '1px',
      w: '38px',
      h: '38px',
    }),

    red: () => ({
      bg: '#DA5032',
      color: 'white',
      _hover: {
        bg: '#DA5032',
        _disabled: {
          bg: '#DA5032',
        },
      },
    }),

    link: (props) => ({
      fontWeight: 'normal',
      textDecoration: 'underline',
      color:
        props.colorMode === 'dark'
          ? 'dark.text-secondary'
          : 'light.text-secondary',
    }),

    'google-login': (props) => ({
      w: '100%',
      pl: '48px',
      border:
        props.colorMode === 'dark' ? '1px solid rgba(0, 0, 0, .25)' : 'none',
      bg: props.colorMode === 'dark' ? 'white' : '#3D6CF1',
      color:
        props.colorMode === 'dark' ? 'light.text-primary' : 'dark.text-primary',
      '& > .chakra-button__icon': {
        pos: 'absolute',
        left: '1px !important',
        p: '8px 10px',
        borderRadius: '7px 0 0 7px',
        bg: 'white',
      },
      _hover: {
        bg: props.colorMode === 'dark' ? '#EEE' : '#4285f4',
        _disabled: {
          bg: props.colorMode === 'dark' ? '#EEE' : '#4285f4',
        },
      },
    }),

    'ats-primary': () => ({
      fontWeight: '700',
      bg: 'ats-primary',
      fontSize: '12px',
      color: 'white',
      p: '10px 12px',
      filter: 'drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.05))',
      _hover: {
        filter: ' drop-shadow(0px 4px 8px rgba(16, 24, 40, 0.05))',
        bg: 'ats-primary',
        _disabled: {
          bg: 'ats-primary',
          opacity: 0.3,
        },
      },
    }),
    'ats-secondary': () => ({
      fontWeight: 600,
      fontSize: '12px',
      bg: 'white',
      borderColor: 'border-color',
      borderWidth: '1px',
      p: '10px 12px',
      filter: 'drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.05))',
      _hover: {
        color: 'ats-primary',
        filter: ' drop-shadow(0px 4px 8px rgba(16, 24, 40, 0.05))',
      },
    }),
    'ats-pending': () => ({
      fontWeight: 600,
      fontSize: '12px',
      bg: 'white',
      borderColor: '#F4A100',
      borderWidth: '1px',
      // p: '0px 8px',
      borderRadius: 'xs',
      filter: 'drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.05))',
      _hover: {
        color: 'ats-primary',
        filter: ' drop-shadow(0px 4px 8px rgba(16, 24, 40, 0.05))',
      },
    }),
    'ats-rejected': () => ({
      fontWeight: 600,
      fontSize: '12px',
      bg: 'white',
      borderColor: '#A32020',
      borderWidth: '1px',
      // p: '0px 8px',
      borderRadius: 'xs',
      filter: 'drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.05))',
      _hover: {
        color: 'ats-primary',
        filter: ' drop-shadow(0px 4px 8px rgba(16, 24, 40, 0.05))',
      },
    }),
    'ats-approved': () => ({
      fontWeight: 600,
      fontSize: '12px',
      bg: 'white',
      borderColor: '#5F9634',
      borderWidth: '1px',
      // p: '0px 8px',
      borderRadius: 'xs',
      filter: 'drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.05))',
      _hover: {
        color: 'ats-primary',
        filter: ' drop-shadow(0px 4px 8px rgba(16, 24, 40, 0.05))',
      },
    }),
    'ats-tertiary': () => ({
      fontWeight: 500,
      fontSize: '12px',
      bg: 'ats-tertiary',
      border: 'none',
      color: 'ats-primary',
      p: '10px 12px',
    }),

    'btn-delete': () => ({
      fontWeight: '700',
      bg: 'color-danger',
      fontSize: '12px',
      color: 'white',
      p: '10px 12px',
      filter: 'drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.05))',
      _hover: {
        filter: ' drop-shadow(0px 4px 8px rgba(16, 24, 40, 0.05))',
        bg: 'color-danger',
        opacity: 0.8,
        _disabled: {
          bg: 'color-danger',
          opacity: 0.3,
        },
      },
    }),

    // New button variants
    primary: () => ({
      ...primaryBase,
      height: '2rem',
      padding: '6px 12px',
    }),
    'primary-lg': () => ({
      ...primaryBase,
      height: '2.75rem',
      padding: '12px 24px',
    }),
    secondary: () => ({
      ...secondaryBase,
      height: '2rem',
      padding: '6px 12px',
    }),
    'secondary-lg': () => ({
      ...secondaryBase,
      height: '2.75rem',
      padding: '12px 24px',
    }),
    tertiary: () => ({
      ...tertiaryBase,
      height: '2rem',
      padding: '6px 12px',
    }),
    'tertiary-lg': () => ({
      ...tertiaryBase,
      height: '2.75rem',
      padding: '12px 24px',
    }),
    quaternary: () => ({
      ...quaternaryBase,
      height: '2rem',
      padding: '6px 12px',
    }),
    'quaternary-lg': () => ({
      ...quaternaryBase,
      height: '2.75rem',
      padding: '12px 24px',
    }),
    danger: () => ({
      ...dangerBase,
      height: '2rem',
      padding: '6px 12px',
    }),
  },

  sizes: {
    sm: {
      height: '38px',
      fontSize: 'sm',
      px: 'lg',
    },
  },

  defaultProps: {
    variant: 'primary',
  },
};
